export const Total_Active_Items_Count_Payload = {
          name: "Total Active Items",
          // owner: "Administrator",
          // creation: "2020-07-20 20:17:16.568132",
          // modified: "2020-07-22 16:56:33.747156",
          // modified_by: "Administrator",
          // docstatus: 0,
          // idx: 0,
          // is_standard: 1,
          // module: "Selling",
          // label: "Annual Sales",
          // type: "Document Type",
          function: "Count",
          document_type: "Item",
          // is_public: 1,
          show_percentage_stats: 1,
          stats_time_interval: "Weekly",
          // filters_json: "[[\"Sales Order\",\"status\",\"not in\",[\"Draft\",\"Cancelled\",\"Closed\",null],false],[\"Sales Order\",\"docstatus\",\"=\",\"1\",false],[\"Sales Order\",\"modified\",\"Timespan\",\"this year\",false]]",
          // dynamic_filters_json: "[[\"Sales Order\",\"company\",\"=\",\"frappe.defaults.get_user_default(\\\"Company\\\")\"]]",
          // doctype: "Number Card",
          // __last_sync_on: "2025-07-31T09:22:28.985Z"
          };       

export const Total_Warehouses_Count_Payload = {
            name: "Total Warehouses",
            // owner: "Administrator",
            // creation: "2020-07-20 20:17:16.596857",
            // modified: "2020-07-22 14:19:28.833784",
            // modified_by: "Administrator",
            // docstatus: 0,
            // idx: 2,
            // is_standard: 1,
            // module: "Selling",
            // label: "Sales Orders to Deliver",
            // type: "Document Type",
            function: "Count",
            document_type: "Warehouse",
            is_public: 1,
            show_percentage_stats: 0,
            stats_time_interval: "Weekly",
            // filters_json: JSON.stringify([
            //   ["Sales Order", "status", "in", ["To Deliver and Bill", "To Deliver", null], false],
            //   ["Sales Order", "docstatus", "=", "1", false]
            // ]),
            // dynamic_filters_json: JSON.stringify([
            //   ["Sales Order", "company", "=", "frappe.defaults.get_user_default(\"Company\")"]
            // ]),
            // doctype: "Number Card",
            // __last_sync_on: "2025-08-01T06:31:18.410Z"
          };

export const Active_Customer_Count_Payload = {
  name: "Active Suppliers",
  // owner: "Administrator",
  // creation: "2020-07-20 20:17:16.653866",
  // modified: "2020-07-22 14:20:32.268103",
  // modified_by: "Administrator",
  // docstatus: 0,
  // idx: 2,
  // is_standard: 1,
  // module: "Selling",
  // label: "Active Customers",
  // type: "Document Type",
  function: "Count",
  document_type: "Supplier",
  is_public: 1,
  show_percentage_stats: 1,
  stats_time_interval: "Monthly",
  // filters_json: JSON.stringify([
  //   ["Customer", "disabled", "=", "0"]
  // ]),
  // dynamic_filters_json: "", // This is an empty string, so keep it as-is
  // doctype: "Number Card",
  // __last_sync_on: "2025-08-01T06:31:18.576Z"
};  

export const Total_Stock_Value_Count_Payload = {
          name: "Total Stock Value",
          // owner: "Administrator",
          // creation: "2020-07-20 20:17:16.625001",
          // modified: "2020-07-22 14:20:09.918626",
          // modified_by: "Administrator",
          // docstatus: 0,
          // idx: 2,
          // is_standard: 1,
          // module: "Selling",
          // label: "Sales Orders to Bill",
          // type: "Document Type",
          function: "Sum",
          aggregate_function_based_on: "stock_value",
          document_type: "Bin",
          is_public: 1,
          show_percentage_stats: 1,
          stats_time_interval: "Weekly",
          // filters_json: JSON.stringify([
          //   ["Sales Order", "status", "in", ["To Deliver and Bill", "To Bill", null], false],
          //   ["Sales Order", "docstatus", "=", "1", false]
          // ]),
          // dynamic_filters_json: JSON.stringify([
          //   ["Sales Order", "company", "=", "frappe.defaults.get_user_default(\"Company\")"]
          // ]),
          // doctype: "Number Card",
          // __last_sync_on: "2025-08-01T06:31:18.489Z"
        };



export const Total_Qty_Grn_Detail_Count_Payload = {
  "name": "qty of Purchase Receipt",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-01 17:15:36.175668",
  // "modified": "2025-09-02 12:21:18.270343",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "qty of Purchase Receipt",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "total_qty",
  "document_type": "Purchase Receipt",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Purchase Receipt\",\"posting_date\",\"Between\",[\"2025-06-02\",\"2025-09-02\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T08:11:04.544Z"
}


export const Total_Qty_Putaway_Detail_Count_Payload = {
 "name": "Amount of Putaway",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-02 15:37:16.809368",
  // "modified": "2025-09-02 15:37:25.812718",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Amount of Putaway",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "total_amount",
  "document_type": "Stock Entry",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "INR",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Stock Entry\",\"posting_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T10:08:01.760Z"
}
export const Total_Qty_Sell_Order_Detail_Count_Payload = {
  "name": "Sales Order total amt",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-08-27 10:40:06.213845",
  // "modified": "2025-08-27 10:40:19.624563",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Sales Order total amt",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "base_grand_total",
  "document_type": "Sales Order",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "INR",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Sales Order\",\"transaction_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T10:59:00.000Z"
}

export const Total_Qty_Sales_Invoice_Detail_Count_Payload = {
  "name": "Amt in sales inovice",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-02 17:22:10.518238",
  // "modified": "2025-09-02 17:22:16.602762",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Amt in sales inovice",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "base_grand_total",
  "document_type": "Sales Invoice",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "INR",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Sales Invoice\",\"posting_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T11:58:22.066Z"
}




export const Total_Qty_Putaway_Detail_Count_Payload2 = {
  "name":"Qty of putaway",
    "owner":"ajay@gmail.com",
    "creation":"2025-09-02 15:35:37.366538",
    "modified":"2025-09-02 16:23:37.858539",
    "modified_by":"ajay@gmail.com",
    "docstatus":0,
    "idx":0,"is_standard":1,
    "module":"Stackerbee Mobile WMS",
    "label":"Qty of putaway","type":"Document Type"
    ,"function":"Sum",
    "aggregate_function_based_on":"fg_completed_qty",
    "document_type":"Stock Entry","parent_document_type":"",
    "report_function":"Sum","is_public":0,"currency":"",
    "show_percentage_stats":0,"stats_time_interval":"Daily",
    "filters_json":"[[\"Stock Entry\",\"posting_date\",\"Between\",[\"2025-04-01\",\"2025-09-02\"],false]]",
    "dynamic_filters_json":"[]","doctype":"Number Card","__last_sync_on":"2025-09-02T10:54:43.792Z"
  }

export const Total_Qty_Sales_Order_Detail_Count_Payload2 = {
  "name": "Sales Order total QTY",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-08-27 10:36:32.815691",
  // "modified": "2025-08-27 10:36:50.067755",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Sales Order total QTY",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "total_qty",
  "document_type": "Sales Order",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Sales Order\",\"transaction_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T10:58:59.977Z"
}


export const Total_Qty_Sales_Invoice_Detail_Count_Payload2 = {
  "name": "qty in Sales invoice",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-02 17:23:51.504808",
  // "modified": "2025-09-02 17:24:13.169781",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "qty in Sales invoice",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "total_qty",
  "document_type": "Sales Invoice",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Sales Invoice\",\"posting_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T11:58:22.072Z"
}



  






export const Total_Qty_Pick_List_Detail_Count_Payload2 = {
  "name": "Pick list Qty",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-02 17:06:28.634478",
  // "modified": "2025-09-02 17:06:49.539181",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Pick list Qty",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "for_qty",
  "document_type": "Pick List",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[[\"Pick List\",\"posting_date\",\"Between\",[\"{{fromDate}}\",\"{{toDate}}\"],false]]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T11:37:21.972Z"
}




export const Total_Qty_Grn_Detail_Count_Payload2 = {
  "name": "Amount of Purchase Recript",
  // "owner": "ajay@gmail.com",
  // "creation": "2025-09-02 14:38:09.565274",
  // "modified": "2025-09-02 14:38:17.913285",
  // "modified_by": "ajay@gmail.com",
  // "docstatus": 0,
  // "idx": 0,
  // "is_standard": 1,
  "module": "Stackerbee Mobile WMS",
  "label": "Amount of Purchase Recript",
  "type": "Document Type",
  "function": "Sum",
  "aggregate_function_based_on": "base_grand_total",
  "document_type": "Purchase Receipt",
  // "parent_document_type": "",
  // "report_function": "Sum",
  // "is_public": 0,
  // "currency": "INR",
  // "show_percentage_stats": 0,
  // "stats_time_interval": "Daily",
  // "filters_json": "[]",
  // "dynamic_filters_json": "[]",
  // "doctype": "Number Card",
  // "__last_sync_on": "2025-09-02T09:20:29.633Z"
}

      
export const createFilterState = (timeInterval = 'Monthly', extraFields = {}) => ({
  dateFilters: [{ label: "From Date", value: '' }, { label: "To Date", value: '' }],
  timeInterval,
  ...extraFields
});
